import {
  ComponentPropsOptions,
  defineComponent,
  h
} from '@vue/composition-api';
import { SimpleBezierEdgeProps } from '../../types';
import { Position } from '../../types';
import BaseEdge from './BaseEdge.vue';
import { getSimpleBezierPath } from './utils';

const SimpleBezierEdge = defineComponent<SimpleBezierEdgeProps>({
  name: 'SimpleBezierEdge',
  props: [
    'sourcePosition',
    'targetPosition',
    'label',
    'labelStyle',
    'labelShowBg',
    'labelBgStyle',
    'labelBgPadding',
    'labelBgBorderRadius',
    'sourceY',
    'sourceX',
    'targetX',
    'targetY',
    'markerEnd',
    'markerStart',
    'interactionWidth',
    'data'
  ] as ComponentPropsOptions<SimpleBezierEdgeProps>,

  setup(props, { attrs }) {
    return () => {
      const [path, labelX, labelY] = getSimpleBezierPath({
        ...props,
        sourcePosition: props.sourcePosition ?? Position.Bottom,
        targetPosition: props.targetPosition ?? Position.Top
      });

      return h(BaseEdge as any, {
        attrs: {
          path,
          labelX,
          labelY,
          ...attrs
        },

        props: props
      });
    };
  }
});

export default SimpleBezierEdge;
